import {
    OperationGroup,
    PreviewFormValues,
} from 'components/customer/Preview3D/types';
import {TemplateVariable} from 'components/customer/Preview3D/usePreview3DData';
import {RoomPlannerProduct} from 'components/customer/RoomPlanner/types';

export interface ProductAttributes {
    hasInsetDrawer: boolean;
    hasMicrowaveDrawer: boolean;
    isInnerDrawerOnly: boolean;
    isPantry: boolean;
    isWallOvenProduct: boolean;
}

export interface PartAttributes extends ProductAttributes {
    isDrawer: boolean;
    isDrawerFront: boolean;
    isInnerDrawer: boolean;
    isBinDrawer: boolean; // NOT inner drawer
    isBinInnerDrawer: boolean;
    isMicrowaveDrawer: boolean;
    isInsetDrawer: boolean;
    isDoorPullout: boolean;
}

export const getProductAttributes = (
    variables: TemplateVariable,
    values: RoomPlannerProduct | PreviewFormValues
): ProductAttributes => {
    const isPantry = variables?.shelfType === 'PANTRY';
    const hasInsetDrawer = Boolean(variables.hasInsetDrawer);
    const hasMicrowaveDrawer = Boolean(
        values?.microwave_opening_height > 0 && !variables?.isWallOvenProduct
    );
    const isInnerDrawerOnly = Boolean(variables.innerDrawerOnly);
    const isWallOvenProduct = Boolean(variables?.isWallOvenProduct);

    return {
        hasInsetDrawer,
        hasMicrowaveDrawer,
        isInnerDrawerOnly,
        isPantry,
        isWallOvenProduct,
    };
};

export const getPartAttributes = (
    operationGroup: OperationGroup,
    variables: TemplateVariable,
    values: RoomPlannerProduct | PreviewFormValues
): PartAttributes => {
    const {
        hasInsetDrawer,
        hasMicrowaveDrawer,
        isInnerDrawerOnly,
        isPantry,
        isWallOvenProduct,
    } = getProductAttributes(variables, values);
    const partId = operationGroup.PartID?.toLowerCase() ?? '';

    const isBinInnerDrawer = Boolean(operationGroup.IsBinWithInnerDrawer);
    const isDrawer = Boolean(
        operationGroup.IsDrawerFront ||
        operationGroup.IsDrawerBottom ||
        operationGroup.IsDrawerBack ||
        operationGroup.IsDrawerRunner ||
        operationGroup.IsDoorPullout
    );

    const isDrawerFront = Boolean(
        operationGroup.IsDrawerFront ||
        operationGroup.IsDoorPullout ||
        partId.toLowerCase().includes('drawerfront') // partID check is specifically for bin product's inner drawer front which have isDrawerBack: true, not isDrawerFront
    );

    const isBinDrawer = Boolean(
        isDrawer &&
        (variables.isBinProduct || variables.isBinWithInnerDrawerProduct) &&
        !isBinInnerDrawer
    );
    const isInnerDrawer =
        Boolean(isDrawer && variables?.innerDrawerCount && !isBinDrawer) ||
        values.isInnerDrawer;
    const isInsetDrawer = isDrawer && hasInsetDrawer;
    const isMicrowaveDrawer = isDrawer && hasMicrowaveDrawer;
    const isDoorPullout = Boolean(operationGroup.IsDoorPullout);

    return {
        isDrawer,
        isDrawerFront,
        isInnerDrawer,
        isBinDrawer,
        isBinInnerDrawer,
        isMicrowaveDrawer,
        isInsetDrawer,
        isDoorPullout,
        hasInsetDrawer,
        hasMicrowaveDrawer,
        isInnerDrawerOnly,
        isPantry,
        isWallOvenProduct,
    };
};
